module.exports = __webpack_public_path__ + "img/framer.7ca8baf4.svg";